import { Form, Formik, FormikHelpers, FormikProps } from 'formik'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import MandatForm, { IMandatFields } from 'src/components/Forms/ManagerMandatForm'
import AuthByCodeForm, { AuthByCodeFields } from 'src/components/Forms/ManagerMandatForm/AuthByCode'
import validateAuthByCodeForm from 'src/components/Forms/ManagerMandatForm/AuthByCode/validate'
import SignatureMethodChoice, { ESecurityMethods } from 'src/components/Forms/ManagerMandatForm/SignatureMethodeChoice'
import validateMandatForm from 'src/components/Forms/ManagerMandatForm/validate'
import InfoCard from 'src/components/infoCard'
import SuccessMessage from 'src/components/SuccessMessage'
import { validateOtpCode } from 'src/services/authMandat'
import request from 'superagent'
import './index.css'
import { MandatManagerStatus } from 'src/constants/status'
import { sendNewInfo } from 'src/services/customer'

const MandatManager: React.FC = () => {
  const [showMandatForm, setshowMandatForm] = useState(false)
  const [messageError, setErrorMessage] = useState('')
  const [clientInfo, setClientInfo] = useState<any>(null)
  const [showSignatureChoice, setShowSignatureChoice] = useState(false)
  const [mandatValues, setMandatValues] = useState<IMandatFields | null>(null)
  const [showSuccessScreen, setShowSuccessScreen] = useState(false)

  // Hydrate depuis localStorage si dispo
  useEffect(() => {
    const storedClient = localStorage.getItem('clientInfo')
    if (storedClient) {
      setClientInfo(JSON.parse(storedClient))
      setshowMandatForm(true)
    }
  }, [])

  const onSubmit = async (values: AuthByCodeFields, formik: FormikHelpers<AuthByCodeFields>) => {
    try {
      const response = await validateOtpCode({
        clientId: values.identifiant,
        email: values.email,
        code: Number(values.code.join('')),
      })

      if (response) {
        const { clientInfo } = response
        setClientInfo(clientInfo)
        localStorage.setItem('clientInfo', JSON.stringify(clientInfo))
        setshowMandatForm(true)
        setErrorMessage('')
      }
    } catch (error: any) {
      console.error('Erreur capturée :', error)

      if (error?.message) {
        setErrorMessage(error.message)
      } else if (error?.response?.body?.message) {
        setErrorMessage(error.response.body.message)
      } else {
        setErrorMessage('Une erreur inconnue est survenue.')
      }
    }
  }

  const onSubmit2 = async (values: IMandatFields, formik: FormikHelpers<IMandatFields>) => {
    setMandatValues(values)
    setShowSignatureChoice(true)
    let customerUpdated
    try {
      if (!clientInfo) return

      const payload = {
        iban: values.iban,
        bic: values.bic,
        firstname: values.firstname,
        lastname: values.lastname,
        status: MandatManagerStatus.EN_COURS,
      }

      customerUpdated = await request.patch(`${process.env.REACT_APP_API_URL}/customers/${clientInfo.id}`).send(payload)
    } catch (error) {
      console.error('Erreur lors de la mise à jour du client avec IBAN/BIC', error)
    }
    const client = customerUpdated?.body
    setClientInfo(client)
    localStorage.setItem('clientInfo', JSON.stringify(client))
    toast.success('Le client à été" mis à jour avec succès!')
    return customerUpdated
  }

  const updateStatus = async (status: string) => {
    try {
      if (!clientInfo) return

      const cliendId = clientInfo.id
      const payload = {
        status: status,
      }
      await sendNewInfo(cliendId, payload)
    } catch (error) {
      console.error('Erreur lors de la mise à jour du status', error)
    }
  }

  const handleReset = async () => {
    await updateStatus(MandatManagerStatus.ANNULE)
    localStorage.removeItem('clientInfo')
    setClientInfo(null)
    setMandatValues(null)
    setshowMandatForm(false)
    setShowSignatureChoice(false)
    setErrorMessage('')
  }

  const onSubmit3 = async (values: IMandatFields, formik: FormikHelpers<IMandatFields>) => {
    try {
      await updateStatus(MandatManagerStatus.FINALISE)
      setShowSuccessScreen(true)
      localStorage.removeItem('signUrl')
      localStorage.removeItem('clientInfo')
    } catch (err) {
      console.error('Erreur lors de la mise à jour du client', err)
    }
  }

  const renderSignatureMethodChoice = (formikProps: FormikProps<IMandatFields>) => (
    <SignatureMethodChoice {...formikProps} onReset={handleReset} />
  )

  return (
    <>
      {showSuccessScreen ? (
        <SuccessMessage />
      ) : !showMandatForm ? (
        <div className="wrap">
          {/* Étape 1 - Auth */}
          <Formik
            initialValues={{ identifiant: '', email: '', code: [null, null, null, null, null, null] }}
            onSubmit={onSubmit}
            component={AuthByCodeForm}
            validationSchema={validateAuthByCodeForm}
          />
          {messageError && <div style={{ color: 'rgb(210, 38, 48)', textAlign: 'center' }}>{messageError}</div>}
        </div>
      ) : !showSignatureChoice ? (
        <div>
          {/* Étape 2 - Formulaire Mandat */}
          <InfoCard clientInfo={clientInfo} />
          <div className="w-4/5 mx-auto pt-3">
            <Formik
              initialValues={{
                sepaAccepted: false,
                iban: '',
                bic: '',
                rib: null,
                firstname: '',
                lastname: '',
                captchaValidation: false,
                clientInfo,
              }}
              onSubmit={onSubmit2}
              validationSchema={validateMandatForm}
            >
              {(FormikProps) => (
                <Form onSubmit={FormikProps.handleSubmit}>
                  <MandatForm {...FormikProps} errors={FormikProps.errors} errorsServer={[]} />
                  <div className="w-full flex flex-col mb-5 md:flex-row justify-around items-center">
                    <button
                      className="cta-mandat-reset my-2 flex-grow-0"
                      style={{ backgroundColor: '#EFEFEF', color: 'black', width: '280px' }}
                      type="button"
                      onClick={handleReset}
                    >
                      Recommencer la procédure
                    </button>
                    <button
                      style={{ width: '260px', position: 'relative' }}
                      className="cta-mandat my-2 flex-grow-0"
                      type="submit"
                    >
                      Valider et Continuer
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      ) : (
        <Formik
          initialValues={{
            securityMethod: '',
            sepaAccepted: false,
            iban: '',
            bic: '',
            clientInfo: clientInfo,
          }}
          onSubmit={onSubmit3}
          enableReinitialize={true}
        >
          {renderSignatureMethodChoice}
        </Formik>
      )}
    </>
  )
}

export default MandatManager
